import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { enterStaffPortal, applyStaffPortalDocument } from "@/lib/staffPortal";
import { readKitchenHubBootstrapToken } from "@/lib/kitchenHubToken";
import { withOpsBase } from "@/lib/opsBase";

const PINK = "#EE2677";

/** Physical QR on tray → open KA hub scan (resolves kitchen token if needed). */
export default function ProductionUnitScanRedirect() {
  const { code } = useParams();
  const toteCode = (code || "").trim().toUpperCase();
  const [err, setErr] = useState("");

  useEffect(() => {
    if (!toteCode) {
      setErr("Invalid tray code");
      return;
    }

    enterStaffPortal("kitchen", `${window.location.origin}/ka/t/${encodeURIComponent(toteCode)}`);
    applyStaffPortalDocument("kitchen");

    const q = new URLSearchParams(window.location.search);
    const role = (q.get("role") || "froster").trim().toLowerCase();

    const tokenFromUrl = (q.get("token") || "").trim();
    const token = tokenFromUrl || readKitchenHubBootstrapToken();

    if (token) {
      const params = new URLSearchParams({ token, scan: toteCode, role });
      window.location.replace(`${withOpsBase("/pp/hub")}?${params.toString()}`);
      return;
    }

    let cancelled = false;
    fetch(`/api/production/tote/entry/${encodeURIComponent(toteCode)}?role=${encodeURIComponent(role)}`)
      .then(async (r) => {
        const data = await r.json().catch(() => ({}));
        if (cancelled) return;
        if (r.ok && data.redirect_url) {
          window.location.replace(data.redirect_url);
          return;
        }
        setErr(typeof data.detail === "string" ? data.detail : "Could not open kitchen scan");
      })
      .catch(() => {
        if (!cancelled) setErr("Network error — try again");
      });

    return () => {
      cancelled = true;
    };
  }, [toteCode]);

  if (err) {
    return (
      <div
        style={{
          minHeight: "100dvh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: 24,
          background: "#F5F2EA",
          fontFamily: "system-ui, sans-serif",
        }}
      >
        <div
          style={{
            maxWidth: 360,
            background: "#FEF2F2",
            border: "1px solid #FECACA",
            borderRadius: 14,
            padding: 16,
            color: "#B91C1C",
            fontWeight: 700,
            fontSize: 14,
            textAlign: "center",
          }}
        >
          {err}
        </div>
      </div>
    );
  }

  return (
    <div
      style={{
        minHeight: "100dvh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#F5F2EA",
        fontFamily: "system-ui, sans-serif",
        color: PINK,
        fontWeight: 800,
      }}
    >
      Opening tray {toteCode}…
    </div>
  );
}
